/** Slugify a team name into a URL/ID-safe identifier.
 *
 * Lowercases, collapses every non-alphanumeric run into a single
 * `-`, trims leading / trailing dashes, and caps at 64 chars to
 * match the backend's `teams.slug` column constraint.
 *
 * Shared between `/admin/teams` (M8b new-team modal) and
 * `/welcome` (M9b step 1) so the auto-derived slug is identical
 * across both surfaces.
 */
export function slugify(value: string): string {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 64);
}
